import React from 'react'
import { Text } from 'rebass'
import { useTranslation } from 'react-i18next'
import { ButtonPrimary } from '../Button'
import Column, { AutoColumn } from '../Column'
import { PaddedColumn } from './styleds'
import { useDarkModeManager } from '../../state/user/hooks'

import listLight from '../../assets/images/token-list/lists-light.png'
import listDark from '../../assets/images/token-list/lists-dark.png'

export default function ListIntroduction({ onSelectList }: { onSelectList: () => void }) {
  const { t } = useTranslation()
  const [isDark] = useDarkModeManager()

  return (
    <Column style={{ width: '100%', flex: '1 1' }}>
      <PaddedColumn>
        <AutoColumn gap="14px">
          <img style={{ width: '120px', margin: '0 auto' }} src={isDark ? listDark : listLight} alt={t('tokenListPreview')} />
          <Text style={{ marginBottom: '8px', textAlign: 'center' }}>
            {t('tokenListIntro')}{' '}
          </Text>
          <ButtonPrimary onClick={onSelectList} id="list-introduction-choose-a-list">
            {t('chooseList')}
          </ButtonPrimary>
        </AutoColumn>
      </PaddedColumn>
    </Column>
  )
}
